export default {
    formatDate: {
        formatDateTime: function (val) { // 1487935440000-> 2017-02-24 19:24
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val),
                    y = date.getFullYear(),
                    m = date.getMonth() + 1;

                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();

                d = d < 10 ? ('0' + d) : d;
                var h = date.getHours();

                h = h < 10 ? ('0' + h) : h;
                var minute = date.getMinutes();

                minute = minute < 10 ? ('0' + minute) : minute;
                return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
            }
        },
        formatTime: function (val) { // 1487935440000-> 2017-02-24 19:24
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val),
                    y = date.getFullYear(),
                    m = date.getMonth() + 1;

                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();

                d = d < 10 ? ('0' + d) : d;
                var h = date.getHours(),
                    minute = date.getMinutes();

                h = h < 10 ? ('0' + h) : h;
                minute = minute < 10 ? ('0' + minute) : minute;
                return h + ':' + minute;
            }
        },
        formatDateTimeSecond: function (val) { // 1487935440000-> 2017-02-24 19:24:00
            if (val === undefined || val === null || val === '' || val === 'null') {
                return '';
            } else {
                var date = new Date(val),
                    y = date.getFullYear(),
                    m = date.getMonth() + 1;

                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();

                d = d < 10 ? ('0' + d) : d;
                var h = date.getHours();

                h = h < 10 ? ('0' + h) : h;

                var minute = date.getMinutes();

                minute = minute < 10 ? ('0' + minute) : minute;
                var second = date.getSeconds();

                second = second < 10 ? ('0' + second) : second;
                return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
            }
        },
        formatDate: function (val) { // 1487935440000-> 2017-02-24
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;

                m = m < 10 ? '0' + m : m;
                var d = date.getDate();

                d = d < 10 ? ('0' + d) : d;
                return y + '-' + m + '-' + d;
            }
        },
        fmtDateTime: function (val) { // mtG2939939-> 2017-02-24 19:24
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

                return Y + M + D + h + m;
            }
        },
        fmtDateTimeSecond: function (val) { // mtG2939939-> 2017-02-24 19:24:00
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

                return Y + M + D + h + m + s;
            }
        },
        fmtDate: function (val) { // mtG2939939-> 2017-02-24
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());

                return Y + M + D;
            }
        },
        fmtTime: function (val) { // mtG2939939-> 15:30
            if (val === undefined || val === null || val === '') {
                return '';
            } else {
                var date = new Date(val);
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

                return h + m;
            }
        },
        nowFormatDate: function (_time) { // 当前时间多少小时之后-->*年*月*日 *时*分
            var today = new Date();
            var times = today.getTime() + _time; // 获取毫秒数 ，1000*60*60*24*day

            today.setTime(times);  // 注意，这行是关键代码
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var strDate = today.getDate();
            var seperator1 = '-';
            var seperator2 = ':';

            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + today.getHours() + seperator2 + today.getMinutes();

            return currentdate;
        },
        nextFormatDate: function (_time) { // 当前时间多少小时之后-->*年*月*日 *时*分
            var today = new Date();
            var times = today.getTime() + _time; // 获取毫秒数 ，1000*60*60*24*day

            today.setTime(times);  // 注意，这行是关键代码
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var strDate = today.getDate();
            var strHours = today.getHours();
            var strMinutes = today.getMinutes();
            var seperator1 = '-';
            var seperator2 = ':';

            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            if (strHours >= 0 && strHours <= 9) {
                strHours = '0' + strHours;
            }
            if (strMinutes >= 0 && strMinutes <= 9) {
                strMinutes = '0' + strMinutes;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + strHours + seperator2 + strMinutes + seperator2 + '00';

            return currentdate;
        },
        nowFormatSecond: function (_time) { // 当前时间多少小时之后-->*年*月*日 *时*分*秒
            var today = new Date();
            var times = today.getTime() + _time; // 获取毫秒数 ，1000*60*60*24*day

            today.setTime(times);  // 注意，这行是关键代码
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var strDate = today.getDate();
            var seperator1 = '-';
            var seperator2 = ':';

            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + today.getHours() + seperator2 + today.getMinutes() + seperator2 + today.getSeconds();

            return currentdate;
        },
        getDay: function (day) { // 获取前一天、后一天的日期等
            var today = new Date();
            var times = today.getTime() + 1000 * 60 * 60 * 24 * day;

            today.setTime(times); // 注意，这行是关键代码
            var Year = today.getFullYear();
            var month = today.getMonth() + 1;
            var strDate = today.getDate();

            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            return Year + '-' + month + '-' + strDate;
        },
        formatSeconds: function (value) { //把秒数转化成 *时*分*秒
            var seconds = parseInt(value); // 秒
            var minutes = 0;  // 分
            var hours = 0; // 小时

            if (seconds > 60) {
                minutes = parseInt(seconds / 60);
                seconds = parseInt(seconds % 60);
                if (minutes > 60) {
                    hours = parseInt(minutes / 60);
                    minutes = parseInt(minutes % 60);
                }
            }
            var result = '' + parseInt(seconds) + '秒';

            if (minutes > 0) {
                result = '' + parseInt(minutes) + '分' + result;
            }
            if (hours > 0) {
                result = '' + parseInt(hours) + '小时' + result;
            }
            return result;
        },
        formatSecondsTime: function (value) { //把毫秒数转化成 00:01:02
            let second = parseInt(value / 1000), // 秒
                minute = 0, // 分
                hour = 0, // 小时
                result = '';

            if (value === null || value === '') {
                return '00:00:00';
            }

            if (second > 60) {
                minute = (second - (second % 60)) / 60;
                second = second % 60;

                if (minute > 60) {
                    hour = (minute - (minute % 60)) / 60;
                    minute = minute % 60;

                    result = (hour >= 10 ? hour : '0' + hour) + ':' + (minute >= 10 ? minute : '0' + minute) + ':' + (second >= 10 ? second : '0' + second);
                } else {
                    result = '00:' + (minute >= 10 ? minute : '0' + minute) + ':' + (second >= 10 ? second : '0' + second);
                }
            } else {
                result = '00:00:' + (second >= 10 ? second : '0' + second);
            }

            return result;
        },

        /**
         * [formatDuration 毫秒转换为 时分秒显示，例如：5天02:12:23（还未完成）]
         * @param  {[type]} val [description]
         * @return {[type]}     [description]
         */
        formatDayDuration: function (val) {
            if (val === undefined || val === null || val === '') {
                return '';
            }
            let date = new Date();
            let nowTime = (new Date() - new Date(val)) / 1000;
            let retArr = [];
            let second = nowTime % 60;  // 秒

            retArr.unshift(('0' + second).slice(-2));
            if (nowTime - second > 0) {
                let minute = (nowTime - second) / 60 % 60;

                retArr.unshift(('0' + minute).slice(-2));
                if (nowTime - second - minute * 60 > 0) {
                    let hour = (nowTime - second - minute * 60) / 60 / 60 % 24;

                    if (hour < 10) {
                        retArr.unshift(('0' + hour).slice(-2));
                    } else {
                        retArr.unshift(('' + hour).slice(-2));
                    }

                    let day = (nowTime - second - minute * 60 - (hour * 60 * 60)) / 60 / 60 / 24;

                    retArr.unshift((day + '天').slice(-3));
                } else {
                    retArr.unshift('00');
                }
            } else {
                retArr.unshift('00');
                retArr.unshift('00');
            }

            return retArr.join(':').replace('天:', '天');
        },

        /**
         * 时间格式化
         */
        formatSecondsTime1: function (value) { //把日期（2018-12-07 10:32:22）转化成 00:01:02

            let that = this,
                returnTime = (new Date(value).getTime()) / 1000,
                now = (new Date().getTime()) / 1000,
                second = parseInt(now - returnTime), // 秒
                minute = 0, // 分
                hour = 0, // 小时
                day = 0, // 天
                result = '';


            if (value === null || value === '') {
                return '';
            }

            if (second > 60) {
                minute = (second - (second % 60)) / 60;
                second = second % 60;

                if (minute > 60) {
                    hour = (minute - (minute % 60)) / 60;
                    minute = minute % 60;

                    if (hour >= 24) {
                        day = (hour - (hour % 24)) / 24;
                        hour = hour % 24;
                        
                        result = (day >= 10 ? day : '0' + day) + '天' + (hour >= 10 ? hour : '0' + hour) + ':' + (minute >= 10 ? minute : '0' + minute) + ':' + (second >= 10 ? second : '0' + second);
                    } else {
                        result = '00天' + (hour >= 10 ? hour : '0' + hour) + ':' + (minute >= 10 ? minute : '0' + minute) + ':' + (second >= 10 ? second : '0' + second);
                    }
                } else {
                    result = '00天' + '00:' + (minute >= 10 ? minute : '0' + minute) + ':' + (second >= 10 ? second : '0' + second);
                }
            } else {
                result = '00天00:00:' + (second >= 10 ? second : '0' + second);
            }

            return result;
        },
        formatDuration: function (val) { // 毫秒转换为 时分秒显示，例如：112:12:23(112小时12分钟23秒)
            if (val === undefined || val === null || val === '') {
                return '';
            }
            let retArr = [];
            let second = val % 60;  // 秒

            retArr.unshift(('0' + second).slice(-2));
            if (val - second > 0) {
                let minute = (val - second) / 60 % 60;

                retArr.unshift(('0' + minute).slice(-2));
                if (val - second - minute * 60 > 0) {
                    let hour = (val - second - minute * 60) / 60 / 60;

                    if (hour < 10) {
                        retArr.unshift(('0' + hour));
                    } else {
                        retArr.unshift(('' + hour));
                    }
                } else {
                    retArr.unshift('00');
                }
            } else {
                retArr.unshift('00');
                retArr.unshift('00');
            }

            return retArr.join(':');
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/js/date.js